import React, { useState, useEffect } from 'react';
import {
  preloader,
  iframe
} from "../pages/book-call.module.css"
const IframeWithLoadingSpinner = ({ src, width, height, iframeName }) => {
  const [iframeLoaded, setIframeLoaded] = useState(false);
  const [containerHeight, setContainerHeight] = useState('90vh');

  useEffect(() => {
    const handleResize = () => {
      const windowWidth = window.innerWidth;
    
      if (windowWidth <= 768) {
        setContainerHeight('135vh'); // Mobile view
      } else if (windowWidth <= 1024) {
        setContainerHeight('140vh'); // Tablet view
      } else if (windowWidth <= 1440) {
        setContainerHeight('125vh'); // Smaller laptops
      } else {
        setContainerHeight('90vh'); // Default view for larger screens
      }
    };
    

    // Set initial height
    handleResize();

    // Attach event listener for window resize
    window.addEventListener('resize', handleResize);

    // Cleanup event listener on component unmount
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleIframeLoad = () => {
    // When the iframe has loaded, set iframeLoaded to true
    setIframeLoaded(true);
  };

  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        height: containerHeight,
      }}
    >
      {iframeLoaded ? null : (
        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: 1000,
          }}
        >
          <img src="/AW-preloader.gif" alt="Loading..." width="50" height="50" className={preloader}  />
        </div>
      )}
      <iframe
        src={src}
        width="100%"
        height="100%"
        frameBorder="0"
        onLoad={handleIframeLoad}
        className={iframe}
        title={iframeName}
        style={{ display: iframeLoaded ? 'block' : 'none' }}
      />
    </div>
  );
};

export default IframeWithLoadingSpinner;
